<template>
    <v-row class="pt-2" :class="{ 'mb-8': extraSpace }">
        <v-col cols="12" sm="6" xl="4" class="py-0">
            <slot name="col1"></slot>
        </v-col>
        <v-col cols="12" sm="6" xl="4" offset-xl="1" class="py-0">
            <slot name="col2"></slot>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        extraSpace: Boolean,
    },
}
</script>
